import { render, staticRenderFns } from "./ProgressStepsCard.vue?vue&type=template&id=36da4c86&scoped=true&"
import script from "./ProgressStepsCard.vue?vue&type=script&lang=ts&"
export * from "./ProgressStepsCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressStepsCard.vue?vue&type=style&index=0&id=36da4c86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36da4c86",
  null
  
)

export default component.exports